import React, { useState, useEffect } from 'react'
import Icon from 'meinian-package/src/component/icon'
import Button from 'meinian-package/src/baseComponent/button'
import globalData from 'meinian-package/src/common/globalData'
import styles from './index.module.less'

export default ({
  title,
  content,
  onJumpUrl,
  keyValue,
  visible,
  onClose
}) => {
  const [_visible, setVisible] = useState(0)

  useEffect(() => {
    if (!keyValue) {
      setVisible(visible)
    }
  }, [visible])

  useEffect(() => {
    if (keyValue) {
      globalData.get(keyValue, setVisible, 1)
    }
  }, [])

  const _onClose = () => {
    if (keyValue) {
      globalData.set(keyValue, 0)
    }
    setVisible(0)
    onClose?.()
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>
    {!!_visible && <div className={styles['coll-guide-modal']}>
      <div className="coll-guide-modal-content">
        <span className="close-icon" onClick={() => _onClose()}><Icon type="m-guanbi" /></span>
        <div className="coll-guide-modal-content-title">{title}</div>
        <div className="coll-guide-modal-content-info">
          {content}
        </div>
        <div className="coll-guide-modal-content-footer">
          <Button
            type="primary"
            style={{ borderRadius: '6px' }}
            onClick={() => {
              onJumpUrl()
            }}
          >查看详情</Button>
        </div>
      </div>
    </div>}
  </>
}
